import { render, staticRenderFns } from "./ShoutBox.vue?vue&type=template&id=163d6321&scoped=true&"
import script from "./ShoutBox.vue?vue&type=script&lang=ts&"
export * from "./ShoutBox.vue?vue&type=script&lang=ts&"
import style0 from "./ShoutBox.vue?vue&type=style&index=0&id=163d6321&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163d6321",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListItem})
